var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.glyph)?_c('div',{staticClass:"rail-glyph",attrs:{"aria-hidden":"true"}},[_c(_setup.glyph.component,{tag:"component",class:['glyph', _setup.positionClass],style:(_setup.glyphStyle)})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }